import { render } from "./TimerGage.vue?vue&type=template&id=4b4e2be0&scoped=true&ts=true"
import script from "./TimerGage.vue?vue&type=script&lang=ts"
export * from "./TimerGage.vue?vue&type=script&lang=ts"

import "./TimerGage.vue?vue&type=style&index=0&id=4b4e2be0&scoped=true&lang=css"

import exportComponent from "/root/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b4e2be0"]])

export default __exports__